import { Paginated } from 'axios'
import { BaseApi } from './api'
import { TableServiceParams } from './models/common'
import {
  NewParticipation,
  Participation,
  ParticipationConfirmation,
  ParticipationConfirmationFilter,
  ParticipationFilter,
  ParticipationFull,
  ParticipationPendingResponse,
  ShareParticipation,
} from './models/participation'

const participationApi = {
  list(params: ParticipationFilter, tableParams: TableServiceParams) {
    return BaseApi.get<Participation[], Paginated>('/v1/participation', {
      params: { ...params, ...tableParams },
      paginated: true,
    })
  },

  confirmations(params: ParticipationConfirmationFilter, tableParams: TableServiceParams) {
    return BaseApi.get<ParticipationConfirmation[], Paginated>('/v1/participation/confirmations', {
      params: { ...params, ...tableParams },
      paginated: true,
    })
  },

  pending() {
    return BaseApi.get<ParticipationPendingResponse>('/v1/participation/pending')
  },

  download(params: ParticipationFilter, tableParams: TableServiceParams, columns?: string[]) {
    return BaseApi.get<Blob, true>('/v1/participation-report', {
      params: { ...params, ...tableParams, columns },
      paginated: false,
      responseType: 'blob',
    })
  },

  getById(id: number) {
    return BaseApi.get<ParticipationFull>(`/v1/participation/${id}`)
  },

  share(id: number, data: ShareParticipation) {
    return BaseApi.post(`/v1/participation/${id}/share`, data)
  },

  approve(id: number, justification: string, notifyEmails: string[]) {
    return BaseApi.post(`/v1/participation/${id}/allow`, { note: justification, notifyEmails: notifyEmails })
  },

  reprove(id: number, justification: string, notifyEmails: string[]) {
    return BaseApi.post(`/v1/participation/${id}/deny`, { note: justification, notifyEmails: notifyEmails })
  },

  delete(id: number, justification: string) {
    return BaseApi.post(`/v1/participation/${id}/delete`, { note: justification })
  },

  create(data: NewParticipation) {
    return BaseApi.post('/v1/participation', data)
  },

  update(id: number, data: NewParticipation) {
    return BaseApi.post(`/v1/participation/${id}`, data)
  },

  confirm(participationIds: number[], confirmed: boolean) {
    return BaseApi.post('/v1/participation/confirmation', { participationIds, confirmed })
  },
}

export default participationApi
